import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IUser } from '../../../types/interfaces';

interface IUserState extends IUser {
  isLoading?: boolean;
  userAccountSelected?: boolean;
  showSurvey?: boolean;
}

export const initialState: IUserState = {
  token: '',
  id: 0,
  email: '',
  name: '',
  photo: '',
  refresh: '',
  exp: 0,
  isClubeBlack: false,
  isSupport: false,
  belt: '',
  isLogged: false,
  accounts: [],
  isLoading: false,
  userAccountSelected: false,
  showSurvey: false
};

const userSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<Partial<IUser>>) {
      state = { ...state, ...action.payload };
      return state;
    },
    isLogged(state, action: PayloadAction<boolean>) {
      state.isLogged = action.payload;
      return state;
    },
    setIsLoadingAccount(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
      return state;
    },
    setUserAccountSelected(state, action: PayloadAction<boolean>) {
      state.userAccountSelected = action.payload;
      return state;
    },
    setShowSurvey(state, action: PayloadAction<boolean>) {
      state.showSurvey = action.payload;
      return state;
    }
  }
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
